/**
 * Waga pozycji w panelu „Wymaga uwagi”. Backend mówi, jak pilna jest sprawa;
 * na barwę tłumaczy to dopiero front — tony statusów są jego słownikiem.
 */
export enum AttentionSeverity {
  /** Pieniądze albo termin już przepadły — zaległa rata, wariant bez zapisów. */
  CRITICAL = 'CRITICAL',
  /** Zdąży się, jeśli ktoś się tym zajmie — faktura do wystawienia, prawie pełny wariant. */
  WARNING = 'WARNING',
  /** Do wiadomości — nic nie płonie. */
  INFO = 'INFO',
}
